export type ExpectationRule = 'LeftLessRight' | 'LeftGreaterRight';

const EXPECTATION_BY_TEST_KEY: Record<string, ExpectationRule> = {
  CervicalAxialRotation: 'LeftLessRight',
  CervicalLateralFlexion: 'LeftGreaterRight',
  ShoulderIR: 'LeftGreaterRight',
  ShoulderER: 'LeftLessRight',
  ShoulderFlexion: 'LeftLessRight',
  ShoulderAbduction: 'LeftLessRight',
  PelvicRotation: 'LeftLessRight',
  HipExtension: 'LeftLessRight',
  HipAdductionObers: 'LeftLessRight',
  StraightLegRaise: 'LeftLessRight',
  FemoralIR: 'LeftLessRight',
  FemoralER: 'LeftGreaterRight',
  HipAbduction: 'LeftGreaterRight',
};

export const getExpectationForTestKey = (testKey: string): ExpectationRule | null =>
  EXPECTATION_BY_TEST_KEY[testKey] ?? null;

/**
 * Maps AIA-style per-side limitations (deficit vs goal, 0 when side passes) to Left / Right lateralization
 * using the same expectation flip as ROM delta rules, but applied to (limL, limR).
 */
export function lateralizationBiasFromLimitations(
  limL: number,
  limR: number,
  expectation: ExpectationRule
): 'Left' | 'Right' | 'Even' {
  if (limL === limR) return 'Even';
  if (expectation === 'LeftLessRight') {
    return limL > limR ? 'Right' : 'Left';
  }
  return limR > limL ? 'Right' : 'Left';
}
